import { jsx as p } from "react/jsx-runtime";
import { StyledPhoneField as c } from "./styles10.mjs";
import { iconButtonClasses as l, inputAdornmentClasses as u, listClasses as m, paperClasses as a } from "@mui/material";
import { useRef as x, useEffect as d } from "react";
import "./_root.mjs";
import "./_baseGetTag.mjs";
import { useFormFieldSize as f } from "./useFormFieldSize.mjs";
const y = ({ size: n, ...i }) => {
  const t = x(null), e = f(n);
  return d(() => {
    const s = t.current?.querySelector(`.${l.root}`), r = t.current?.querySelector(
      `.${u.root}`
    ), o = () => {
      s?.click();
    };
    return r?.addEventListener("click", o, { capture: !0 }), () => {
      r?.removeEventListener("click", o);
    };
  }, []), /* @__PURE__ */ p(
    c,
    {
      $size: e,
      size: e,
      ...i,
      focusOnSelectCountry: !0,
      forceCallingCode: !0,
      MenuProps: {
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        sx: {
          [`& .${m.root}`]: {
            maxHeight: "240px",
            width: "380px",
            borderRadius: "12px"
          },
          [`& .${a.root}`]: {
            transform: "translateY(4px) !important",
            boxShadow: "0px 5px 5px -3px #00000033, 0px 8px 10px 1px #0000000D"
          }
        }
      },
      ref: t
    }
  );
};
export {
  y as PhoneField
};
//# sourceMappingURL=index22.mjs.map
